export function skip(array = [], count = 0){
    if(count <= 0) return [...array];
    if(array.length <= count) return [];
    return array.slice(count);
}

export function take(array = [], count = 0) {
    if(count <= 0) return [];
    if(array.length <= count) return [...array];
    return array.slice(0, count);
}

export function paging(array=[], page, pageSize) {
    return take(skip(array, (page - 1) * pageSize), pageSize);
}

export function join(left = [], right = [], leftKeyFunc, rightKeyFunc, resultFunc) {
    return left.reduce((j, l) => {
        const rst = right.filter(r => rightKeyFunc(r) === leftKeyFunc(l))
            .map(r => resultFunc(l, r));
        return j.concat(rst);
    }, []);
}